export default "__VITE_ASSET__ddde85b2__"